var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',_vm._g({staticClass:"font-weight-light text-truncate",class:{
		'text-center': _vm.centered,
		'display-1': _vm.large && !_vm.small,
		title: !_vm.large && !_vm.small,
		'font-weight-medium': _vm.bold,
		'subtitle-1': _vm.small,
	},style:({'line-height': '1.4 !important', color: _vm.bold || _vm.$vuetify.theme.dark ? '' : '#828282'})},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }